import ButtonComponent from '@pretto/bricks/components/buttons/Button'
import * as helpers from '@pretto/bricks/components/helpers'
import IllustrationDeprecated from '@pretto/bricks/components/images/IllustrationDeprecated'
import { breakpoints, g } from '@pretto/bricks/components/layout'
import styled from 'styled-components'

export const Card = styled.div`
  ${helpers.boxShadow('card')}
  background-color: ${({ theme }) => theme.colors.neutral4};
  border-radius: ${g(1)};
  padding: ${g(2)} ${g(3)};
  position: relative;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: ${g(4)};
  }
`
export const IllustrationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${g(2)};

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: ${g(3)};
  }
`
export const Illustration = styled(IllustrationDeprecated).attrs(({ $name }) => ({ name: $name }))`
  width: ${g(10)};

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: ${g(16)};
  }
`
export const Button = styled(ButtonComponent).attrs({ isSecondary: true })`
  margin-top: ${g(3)};
`
